import { pathSubscription } from 'nike-re-framejs';

export const searchSuggetionData$ = pathSubscription(['search', 'suggestion', 'searchData']);
export const searchSuggetionText$ = pathSubscription(['search', 'suggestion', 'searchText']);
export const searchResultData$ = pathSubscription(['search', 'result', 'searchData']);
export const searchText$ = pathSubscription(['search', 'searchText']);
